import { render, staticRenderFns } from "./AdminWebsiteSettings.vue?vue&type=template&id=7940ee07&"
import script from "./AdminWebsiteSettings.vue?vue&type=script&lang=js&"
export * from "./AdminWebsiteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports